import {Key, useEffect, useState} from "react";
import {Collapse} from "react-bootstrap";
import {answerColor, cscenterMockupList} from "../../utils/UtilsFunc";
import {useApi} from "../../hooks/ApiProvider/ApiProvider";

const List = ({...props}) => {
  console.log(props);
  const api = useApi();
  
  const [pageInfo, setPageInfo] = useState({});
  const [list, setList] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    page_size: 10,
    total_records: 0,
    total_pages: 0,
    has_next: false,
    has_previous: false
  });
  
  
  const getReady = async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.current_page,
        page_size: pagination.page_size,
        sort_by: 'created_at',
        sort_order: 'desc'
      };
      
      const result = await api.getBoards(params);
      console.log('게시글 목록 조회 응답:', result);
      
      // API 응답이 직접 게시글 배열인 경우
      if (Array.isArray(result)) {
        const boardsWithCollapse = result.map((board: any) => ({
          ...board,
          collapse: false,
          // 기존 mockup 데이터와 호환성을 위한 매핑
          ids: board.id,
          subject: board.subject,
          user_upload_date: new Date(board.created_at).toLocaleDateString('ko-KR'),
          answer: board.status === '답변완료',
          description: board.description,
          comment: board.replies && board.replies.length > 0 ? board.replies[0].content : '',
          answer_upload_date: board.replies && board.replies.length > 0 ? 
            new Date(board.replies[0].created_at).toLocaleDateString('ko-KR') : ''
        }));
        
        setList(boardsWithCollapse);
        setPagination({
          current_page: 1,
          page_size: 10,
          total_records: result.length,
          total_pages: 1,
          has_next: false,
          has_previous: false
        });
      }
      // API 응답이 {boards: [...], pagination: {...}} 구조인 경우
      else if (result.boards) {
        const boardsWithCollapse = result.boards.map((board: any) => ({
          ...board,
          collapse: false,
          // 기존 mockup 데이터와 호환성을 위한 매핑
          ids: board.id,
          subject: board.subject,
          user_upload_date: new Date(board.created_at).toLocaleDateString('ko-KR'),
          answer: board.status === '답변완료',
          description: board.description,
          comment: board.replies && board.replies.length > 0 ? board.replies[0].content : '',
          answer_upload_date: board.replies && board.replies.length > 0 ? 
            new Date(board.replies[0].created_at).toLocaleDateString('ko-KR') : ''
        }));
        
        setList(boardsWithCollapse);
        setPagination(result.pagination);
      }
    } catch (error) {
      console.error('게시글 목록 조회 오류:', error);
      // 오류 발생 시 mockup 데이터 사용
      let temp = cscenterMockupList?.map((val) => {
        return {
          ...val,
          collapse: false,
        }
      });
      setList(temp);
    } finally {
      setLoading(false);
    }
  }
  
  const onHandleCollapse = (collapse:boolean, idx:string, answer:boolean) => {
    if(answer) {
      let temp = list?.map((val:any)=>{
        if(val?.ids === idx) {
          return {
            ...val,
            collapse:collapse,
          }
        }
        return val;
      });
      setList(temp)
    }
  }
  
  const handlePageChange = (page: number) => {
    setPagination(prev => ({ ...prev, current_page: page }));
  }
  
  useEffect(() => {
    getReady();
  }, [pagination.current_page]);
  
  
  return (
    <>
      <div className={`section_wrap sec_wrap_2 list`}>
        <div className={`sec sec_2`}>
          <div className={`btn_group flex justify-center`}>
            <button onClick={()=>props?.actChage(`add`)} className={`btn btn-primary`}>새로운 문의 작성</button>
          </div>
          {/** ------------------------------ 테이블 -------------------------------- **/}
          <div className={`table_box`}>
            {loading ? (
              <div className="text-center py-4">
                <p>게시글을 불러오는 중...</p>
              </div>
            ) : (
            <div className={`table`}>
              {/*표 제목*/}
              <div className={`row_thead`}>
                <div className={`tr`}>
                  <div className={`row_th tit h4_sb`}>제목</div>
                  <div className={`row_th date h4_sb`}>작성일</div>
                  <div className={`row_th answer_state h4_sb`}>답변 상태</div>
                </div>
              </div>
              {/*리스트*/}
              <div className={`tbody`}>
                {/**------------------------------------반복문 구간------------------------------------**/}
                {list?.map((obj: any, idx: Key | null | undefined)=>{
                  let active = obj?.collapse ? `on`:``;
                  return (
                    <div key={idx} className={`row_tr ${active}`}>
                      <div className={`tr`}>
                        <div className={`row_td tit body1`} 
                             style={{cursor: 'pointer'}}
                             onClick={() => props?.actChage(`view&id=${obj?.ids}`)}>
                          {obj?.subject}
                        </div>
                        <div className={`row_td date body1`}>{obj?.user_upload_date}</div>
                        <div className={`row_td answer_state body1 ${active} ${answerColor(obj?.answer)?.color}`}
                             onClick={() => onHandleCollapse(!obj?.collapse,obj?.ids,obj?.answer)}
                             aria-controls="example-collapse-text"
                             aria-expanded={obj?.collapse}
                        >
                          <button className={`btn ${answerColor(obj?.answer)?.color}`}>
                            {answerColor(obj?.answer)?.txt}
                          </button>
                        </div>
                      </div>
                      {/**----------------------------------------답변 화면----------------------------**/}
                      {(obj?.answer) && (
                        <Collapse in={obj?.collapse}>
                          <div className={`table_collapse`}>
                            <div className={`answer_box`}>
                              {/*사용자 문의 내용*/}
                              <div className={`user_answer_txt body1_sb`}>
                                {obj?.description}
                              </div>
                              {/*첨부 이미지*/}
                              <div className={`photo_box`}>
                                {/*반복문 구간*/}
                                <div className={`img_item`}>
                                  <img src={``} alt={`123123`}/>
                                </div>
                                <div className={`img_item`}></div>
                                <div className={`img_item`}></div>
                                <div className={`img_item`}></div>
                              </div>
                            </div>
                            {/*관리자 답변내용*/}
                            <div className={`admin_answer_txt body1`}>
                              <div className={`txt`}>
                                {obj?.comment}
                              </div>
                              <div className={`upload_date`}>{obj?.answer_upload_date}</div>
                            </div>
                          </div>
                        </Collapse>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
            )}
          </div>
          {/** --------------------------- 페이지네이션 ------------------------------ **/}
          {pagination.total_pages > 1 && (
            <div className={`page_box`}>
              <div className={`pagination flex justify-center items-center`}>
                <button 
                  className={`prev`}
                  onClick={() => handlePageChange(pagination.current_page - 1)}
                  disabled={!pagination.has_previous}
                >
                  이전
                </button>
                {/**반복문 구간**/}
                {Array.from({ length: pagination.total_pages }, (_, i) => i + 1).map((pageNum) => (
                  <button 
                    key={pageNum}
                    className={`item ${pageNum === pagination.current_page ? 'on' : ''}`}
                    onClick={() => handlePageChange(pageNum)}
                  >
                    {pageNum}
                  </button>
                ))}
                {/**반복문 구간끝**/}
                <button 
                  className={`prev`}
                  onClick={() => handlePageChange(pagination.current_page + 1)}
                  disabled={!pagination.has_next}
                >
                  다음
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
export default List;